export default "Remplacement des sources lumineuses par luminaires LED haute efficacité (fiche CEE BAT-EQ-127). Geste rapide à déployer, gain mesurable dès la mise en service.";
